<div class="main-content">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header card-header-danger">
                        <!-- <button  class="add-btn" data-toggle="modal" (click)="openAddModal(addtemplate)"  data-target="#adddetail" ><i class="fa fa-plus-square" aria-hidden="true"></i>  add Event</button> -->
                    </div>
                    <div class="card-body">
                        <div class="table-responsive">
                            <table class="table">
                                <thead>
                                  <th style="width: 7%;">Event ID </th>
                                  <th>Start Date</th>
                                  <th>End Date</th>
                                  <th style="width: 30%;">Event Title</th>
                                  <th>Published</th>
                                  <th>Image</th>
                                  <th style="width: 28%;">Action</th>
                                </thead>
                                <tbody>
                                  <tr *ngFor="let event of eventlistgetall; let i = index">
                                    <td>{{i+1}}</td>
                                    <td>{{event.event_startdate | date:'dd MMM yyyy'}}</td>
                                    <td>{{event.event_enddate | date:'dd MMM yyyy'}}</td>
                                    <td>{{event.event_title}}</td>
                                    <td><span *ngIf="event.status == 0">Yes</span>   
                                        <span *ngIf="event.status == 1">No</span>
                                    </td>
                                    <td><img [src]="event.image? imgbaseurl+event.image : ''" class="img-fluid table-img-fix"></td>
                                    <td>
                                      <button class="btn action-btn"  data-toggle="modal" (click)="openEditModal(edittemplate, event)" data-target="#sliderEdit" >
                                          <i class="fa fa-pencil-square-o action-icon" aria-hidden="true"></i>Edit</button>
                                      <button class="btn action-btn action-btn-two" data-toggle="modal" (click)="openDeleteModal(deletetemplate, event)" data-target="#sliderDelete" >
                                          <i class="fa fa-trash action-icon" aria-hidden="true"></i>Delete</button>
                                      <button class="btn action-btn action-btn-three" data-toggle="modal" routerLink="/event/upload-image/{{event.event_id}}" data-target="#sliderDelete" >
                                          <i class="fa fa-picture-o action-icon" aria-hidden="true"></i> Upload Event Images</button>
                                    </td>
                                  </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
  
  <!------------------------------------------------------ ADD  MODAL -------------------------------------------------------->
  
    <ng-template #addtemplate>
        <div class="modal-header">
            <h4 class="modal-title">Add Event</h4>
            <button type="button" class="close" aria-label="Close" (click)="modalRef.hide()">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <div class="modal-body">
            <div class="slider-form">
                <form [formGroup]="eventaddform" #EventAddForm="ngForm">
                  <div class="row">
                      <div class="col-sm-6 pb-20">
                        <mat-form-field class="width-set mt-set">
                          <input matInput [matDatepicker]="startdate" placeholder="Select Start Date" formControlName="event_startdate">
                          <mat-datepicker-toggle matSuffix [for]="startdate"></mat-datepicker-toggle>
                          <mat-datepicker #startdate></mat-datepicker>
                        </mat-form-field>
                      </div>
                      <div class="col-sm-6 pb-20">
                        <mat-form-field class="width-set mt-set">
                          <input matInput [matDatepicker]="enddate" placeholder="Select End Date" formControlName="event_enddate">
                          <mat-datepicker-toggle matSuffix [for]="enddate"></mat-datepicker-toggle>
                          <mat-datepicker #enddate></mat-datepicker>
                        </mat-form-field>
                      </div>
                      <div class="col-sm-6 pb-20">
                          <div class="form-group">
                              <mat-form-field class="example-full-width">
                                <input matInput placeholder="Event Title" type="text" formControlName="event_title">
                              </mat-form-field>
                          </div>
                      </div>
                      <div class="col-sm-6">
                          <div class="form-group  mt-30">
                             <div class="row">
                                <div class="col-sm-5 col-5">
                                   <div class="form-group">
                                      <label for="status">Publish</label>
                                   </div>
                                </div>
                                <div class="col-sm-7 col-7">
                                   <div class="form-group">
                                      <div class="custom-control custom-radio custom-control-inline">
                                         <input type="radio" class="custom-control-input" id="0"  value="0" name="status" formControlName="status" mdbInput >
                                         <label class="custom-control-label" for="0">Yes</label>
                                      </div>
                                      <div class="custom-control custom-radio custom-control-inline">
                                         <input type="radio" class="custom-control-input" id="1"   name="status" value="1" formControlName="status"  mdbInput>
                                         <label class="custom-control-label" for="1">No</label>
                                      </div>
                                   </div>
                                </div>
                             </div>
                          </div>
                       </div>
                      <div class="col-sm-6 pb-20">
                        <div class="form-group">
                            <mat-form-field class="example-full-width">
                                <textarea matInput placeholder="Event Description" formControlName="event_desc"></textarea>
                            </mat-form-field>
                        </div>
                      </div>
                      <div class="col-sm-6 pb-20">
                          <div class="logo-img">
                              <label class="input-group">
                                  <input type="file" name="image" ic="file" (change)="onChangeSetImagePath($event)" style="width:100%;height:5px;z-index:10;opacity:0;" />
                                  <input type="text" style="z-index:0" readonly="readonly" class="form-control upload-img" placeholder="Image" aria-label="Recipient's username" aria-describedby="basic-addon2">
                                  <div class="input-group-append">
                                      <span class="input-group-text chooseimage-btn" id="basic-addon2">CHOOSE IMAGE</span>
                                  </div>
                              </label>
                              <div class="upload-img-box">
                                  <img [src]="defaultImage" style="width: 100%; height: 100%;" class="img-fluid" />
                              </div>
                          </div>
                      </div>
                  </div>
                </form> 
            </div>
        </div>
        <div class="modal-footer">                        
            <button class="btn footer-btn bg-info" (click)="addEventsave()">Add Event</button>
            <button class="btn footer-btn bg-secondary" (click)="modalRef.hide()">cancel</button>
        </div>
    <!-- </div> -->
    </ng-template>
  
  <!----------------------------------------------------- EDIT  MODAL -------------------------------------------------------->
  
    <ng-template #edittemplate>
        <div class="modal-header">
            <h4 class="modal-title">Edit Event</h4>
            <button type="button" class="close" aria-label="Close" (click)="modalRef.hide()">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <div class="modal-body">
            <div class="slider-form">
                <!-- <form [formGroup]="sliderformEdit" #SliderFormEdit="ngForm"> -->
                  <form [formGroup]="eventeditform" #EventEditForm="ngForm">
                      <div class="row">
                          <!-- <div class="col-sm-6 pb-20">
                            <mat-form-field class="width-set mt-set">
                              <input matInput [matDatepicker]="startdate" placeholder="Select Start Date" formControlName="event_startdate">
                              <mat-datepicker-toggle matSuffix [for]="startdate"></mat-datepicker-toggle>
                              <mat-datepicker #startdate></mat-datepicker>
                            </mat-form-field>
                          </div>
                          <div class="col-sm-6 pb-20">
                            <mat-form-field class="width-set mt-set">
                              <input matInput [matDatepicker]="enddate" placeholder="Select End Date" formControlName="event_enddate">
                              <mat-datepicker-toggle matSuffix [for]="enddate"></mat-datepicker-toggle>
                              <mat-datepicker #enddate></mat-datepicker>
                            </mat-form-field>
                          </div> -->
                          <div class="col-sm-6 pb-20">
                              <div class="form-group">
                                  <mat-form-field class="example-full-width">
                                    <input matInput placeholder="Event Title" type="text" formControlName="event_title">
                                  </mat-form-field>
                              </div>
                          </div>
                          <div class="col-sm-6">
                              <div class="form-group  mt-30">
                                 <div class="row">
                                    <div class="col-sm-5 col-5">
                                       <div class="form-group">
                                          <label for="status">Publish</label>
                                       </div>
                                    </div>
                                    <div class="col-sm-7 col-7">
                                       <div class="form-group">
                                          <div class="custom-control custom-radio custom-control-inline">
                                             <input type="radio" class="custom-control-input" id="0"  value="0" name="status" formControlName="status" mdbInput >
                                             <label class="custom-control-label" for="0">Yes</label>
                                          </div>
                                          <div class="custom-control custom-radio custom-control-inline">
                                             <input type="radio" class="custom-control-input" id="1"   name="status" value="1" formControlName="status"  mdbInput>
                                             <label class="custom-control-label" for="1">No</label>
                                          </div>
                                       </div>
                                    </div>
                                 </div>
                              </div>
                           </div>
                          <div class="col-sm-6 pb-20">
                            <div class="form-group">
                                <mat-form-field class="example-full-width">
                                    <textarea matInput placeholder="Event Description" formControlName="event_desc"></textarea>
                                </mat-form-field>
                            </div>
                          </div>
                          <div class="col-sm-6 pb-20">
                              <div class="logo-img">
                                  <label class="input-group">
                                      <input type="file" name="image" ic="file" (change)="onChangeSetImagePath($event)" style="width:100%;height:5px;z-index:10;opacity:0;" />
                                      <input type="text" style="z-index:0" readonly="readonly" class="form-control upload-img" placeholder="Image" aria-label="Recipient's username" aria-describedby="basic-addon2">
                                      <div class="input-group-append">
                                          <span class="input-group-text chooseimage-btn" id="basic-addon2">CHOOSE IMAGE</span>
                                      </div>
                                  </label>
                                  <div class="upload-img-box">
                                      <img [src]="defaultImage" style="width: 100%; height: 100%;" class="img-fluid" />
                                  </div>
                              </div>
                          </div>
                      </div>
                  </form> 
            </div>
        </div>
        <div class="modal-footer">                        
            <button class="btn footer-btn bg-info" (click)="editeventdone()">Save</button>
            <button class="btn footer-btn bg-secondary" (click)="modalRef.hide()">cancel</button>
        </div>
    <!-- </div> -->
    </ng-template>
  
  
  <!----------------------------------------------------- DELETE  MODAL -------------------------------------------------------->
  
    <ng-template #deletetemplate>
        <div class="modal-header">
            <h4 class="modal-title">CONFIRMATION</h4>
            <button type="button" class="close" aria-label="Close" (click)="modalRef.hide()">
            <span aria-hidden="true">&times;</span>
        </button>
        </div>
        <div class="modal-body">
            <h1 style="font-size: 18px;">Are You Sure to Delete This Event ?</h1>
        </div>
        <!--Footer-->
        <div class="modal-footer">                        
            <button class="btn footer-btn bg-info" (click)="deleteeventdone(deleteData)">YES</button>
            <button class="btn footer-btn bg-secondary" (click)="modalRef.hide()">NO</button>
        </div>
        <!-- </div> -->
    </ng-template>
    </div>
  </div>
  